import { Injectable } from '@angular/core';

@Injectable()
export class IntervalService {

    setInterval(handler: any, interval: number): NodeJS.Timeout {
        return setInterval(handler, interval);
    }

    clearInterval(handle: NodeJS.Timeout) {
        clearInterval(handle);
    }
}
